module.exports = __webpack_public_path__ + "../resources/img/grid.f793ea00.svg";